import React, { useState, useEffect } from "react";
import "./ems.css";
import Select from "react-select";
import axios from "axios";
import Timeseries from "./timeseries/timeseries.js";

function Ems(props) {
  return (
    <>
      <h1>Energy Monitoring System</h1>
      <Timeseries/>
    </>
  );
}

export default Ems;
